<template>
  <div
    class="ActivityDetail"
    :style="{
      backgroundColor: BGcolor,
      backgroundImage: `url(${backgroundImg})`,
    }"
  >
    <div
      v-show="headerPosition.imagePath"
      ref="$banner"
      class="banner-wrap"
      @click.stop
    >
      <img
        :src="headerPosition.imagePath"
        @click.stop="toDetail(headerPosition.url, 'banner')"
      />
    </div>
    <transition-group name="nav-transition">
      <div
        v-if="goodsList.length > 0 && show && showBigNav"
        ref="$nav"
        key="big"
        class="nav-left-fixed"
        :style="{ left: left + 'px', background: tabBGColor }"
        @mouseleave="leaveBigNav"
      >
        <h3>{{TLang('活动导航','my')}}</h3>
        <div class="tab-list-fixed">
          <div
            v-for="tab in goodsList"
            v-if="tab.subAdvPositions.length"
            :key="tab.id"
            :class="{
              active: activeValue === tab.id,
              'fixed-item': true,
              'line-clamp-1': true,
            }"
            :style="{
              background: activeValue === tab.id ? tabBGActiveColor : '#fff',
              color: activeValue === tab.id ? tabActiveColor : '#111',
            }"
            @click="scrollIntoFace(tab.id, 230)"
          >
            <template>
              <div>{{ tab.name }}</div>
            </template>
          </div>
        </div>
        <div class="scrollTop" @click="toTop">
          {{TLang('回到顶部','my')}}
          <img :src="require('@assets/images/nav_left_to_top.png')" alt="" />
        </div>
      </div>
      <div
        v-if="goodsList.length > 0 && show && !showBigNav"
        key="small"
        class="nav-left-small"
        :style="{ background: tabBGColor }"
        @mouseenter="showBigNav = true"
        v-html="TLang('第二个活动导航', 'my')"
      >
      </div>
    </transition-group>
    <div class="goodlist-wrap">
      <div v-for="(gitem, gindex) in goodsList" :id="gitem.id" :key="gindex">
        <template
          v-if="gitem.subAdvPositions && gitem.subAdvPositions.length > 0"
        >
          <div
            v-for="(item, index) in gitem.subAdvPositions"
            :key="index"
            class="title-img-box"
          >
            <template v-if="item.platform !== 1">
              <!-- showType === 1 图片 -->
              <div
                v-if="item.showType === 1 && item.imagePath"
                :href="item.url"
                target="_self"
                @click="toDetail(item.url)"
              >
                <img alt="" :src="item.imagePath" />
              </div>
              <!-- showType === 6 商品 -->
              <template
                v-else-if="
                  item.showType === 6 &&
                  item.subAdvPositions &&
                  item.subAdvPositions.length > 0
                "
              >
                <div
                  v-for="(row, rowIndex) in item.subAdvPositions"
                  :key="rowIndex"
                >
                  <template
                    v-if="row.subAdvPositions && row.subAdvPositions.length > 0"
                  >
                    <div v-if="row.maxShowNum === 4" class="row-goods-list">
                      <div
                        v-for="(good, goodIndex) in row.subAdvPositions"
                        :key="goodIndex"
                      >
                        <div class="good-item">
                          <GoodsItem
                            :goods="checkTags(good.goodsInfo)"
                            :purchaseType="good.goodsInfo.purchaseType"
                            :onClick="toPageDetail.bind(undefined, good.goodsInfo,good.url,'DF_GoodsClick')"
                            :onClickAdd="
                              onClickAdd.bind(undefined, good.goodsInfo)
                            "
                            page="activeIndex"
                          />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="lotteryInfo && lotteryInfo.length && lotteryInfo[0].url"
      class="lottery-enter"
      @click="iframeDialog = true"
    >
      <img :src="lotteryInfo[0].imagePath" alt="" />
    </div>
    <SkuPicker
      :visible="SkuPickerShow"
      :goods="activeGoods"
      :onClose="onCloseSkuModal"
      :onAdd="onClickSkuAdd"
    />
    <FixedButton :channelName="TLang('ADS活动页', 'my')" />
    <Dialog
      title=" "
      :visible.sync="dialogVisible"
      width="420px"
      custom-class="product-dialog"
      center
      top="50vh"
      :lock-scroll="false"
      @open="dialogVisible = true"
    >
      <img :src="require('../../assets/images/cart_ok.png')" />
      <div class="title">
        {{TLang('加入购物车成功','my')}}
      </div>
      <div
        v-if="chooseOfAdd.goodsName"
        class="goods-name"
      >
        {{ chooseOfAdd.goodsName }}
      </div>
      <div
        v-if="chooseOfAdd.specValue1 || chooseOfAdd.specName"
        class="goods-sku-name"
      >
        {{TLang('规格','my')}}：{{ chooseOfAdd.specValue1 || chooseOfAdd.specName }}
      </div>
      <div class="btns">
        <button class="close-btn" @click="toPageDetail(chooseOfAdd)">
          {{TLang('查看商品详情','my')}}
        </button>
        <button
          class="buy-btn primary"
          @click="onClickGoBuy"
        >
          {{TLang('去结算','my')}}
        </button>
      </div>
    </Dialog>
    <Dialog
      v-if="lotteryInfo.length"
      title=" "
      :visible.sync="iframeDialog"
      width="420px"
      custom-class="iframe-dialog"
      center
      top="50vh"
      @open="iframeDialog = true"
    >
      <div class="iframe-h5" frameborder="no">
        <iframe ref="h5Iframe" :src="lotteryInfo[0].url" name="h5"></iframe>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GoodsItem from "./../lifeIndex/GoodsItem";
import { fetchaddCart, fetchSkuBySpuId, getActivityTag } from "@fetch/shopping";
import { fetchGoodsTags } from "@fetch";
import Toast from "@components/simpleToast";
import SkuPicker from "@components/SkuPicker";
import FixedButton from "@components/FixedButton";
import { Dialog } from "element-ui";
import Cookies from "js-cookie";
import { gioClickHandle } from "@/utils";
import { dealTagGoods } from "@/utils/special";
export default {
  name: "ActivityDetail",
  components: {
    GoodsItem,
    SkuPicker,
    Dialog,
    FixedButton,
  },
  data() {
    return {
      show: true,
      activeValue: null,
      tabBGColor: "#ff9",
      tabBGActiveColor:
        "linear-gradient(0deg,rgba(119,213,252,1),rgba(76,129,248,1))",
      BGcolor: "#fff",
      tabActiveColor: "#fff",
      tabFont: "#111",
      // showLeftNav: false,
      backgroundImg: "",
      left: 0,
      showNavWidth: 0,
      showBigNav: true,
      addressInfo:
        Cookies.get("address") && JSON.parse(Cookies.get("address") || "{}"),
      chooseOfAdd: {},
      dialogVisible: false,
      activeGoods: {},
      SkuPickerShow: false,
      iframeDialog: false,
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  computed: {
    ...mapGetters("activity", [
      "bannerList",
      "goodsList",
      "headerPosition",
      "pageTitle",
      "lotteryInfo",
    ]),
    ...mapGetters("shopCart", ["getCount"]),
  },
  mounted() {
    gioClickHandle("DF_pageView");
    this.fetchActivityDetail({ id: this.$route.params.id }).then((res) => {
      // this.showLeftNav = this.goodsList.length > 6;
      this.tabBGColor = res.menuColor || "#FFDCDB";
      this.tabBGActiveColor =
        res.menuHighlightColor ||
        "linear-gradient(0deg,rgba(119,213,252,1),rgba(76,129,248,1))";
      this.BGcolor = res.backgroundColor || "#fff";
      this.tabFont = res.menuFontColor || "#111";
      this.tabActiveColor = res.menuFontHighlightColor || "#fff";
      this.backgroundImg = res.backgroundImg || "";
      this.showNavWidth = this.$refs.$nav.offsetWidth + 24;
      this.listenScroll();
      this.listenResize();
     
      // if(this.lotteryInfo.length){
      //   let iframe = document.createElement('iframe');
      //   iframe.src = this.lotteryInfo[0].url;
      //   iframe.style.display = 'none'
      //   document.body.appendChild(iframe)
      // }
    });
    this.cartCount({ ...this.addressInfo });
    window.addEventListener("scroll", this.listenScroll, false);
    window.addEventListener("resize", this.listenResize, false);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.addEventListener("message", this.listenMessage, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
  methods: {
    ...mapActions("activity", ["fetchActivityDetail"]),
    ...mapActions("shopCart", ["cartCount"]),
    listenScroll() {
      const sct = document.documentElement.scrollTop || document.body.scrollTop;
      let show = sct > 210 + this.$refs.$banner.offsetHeight;
      if (this.show !== show) {
        this.show = show;
      }
      this.updateActive();
    },
    // 来自iframe的传值
    listenMessage(e) {
      if (e.data === 101002 || e.data === '99') {
        this.apis.headerApi.getLoginStatus().then((res) => {
          if (res && res.loginFlag === 0) {
            window.location.replace(
              res.loginUrl + "&returnUrl=" + window.location.href
            );
          }
        });
      } else if (e.data.urlPC) {
        window.location.href = e.data.urlPC;
      }
    },
    listenResize() {
      const avaWidth =
        document.documentElement.offsetWidth || document.body.offsetWidth;
      const laveWidth = (avaWidth - 1200) / 2;
      // let navWidth = this.$refs.$nav.offsetWidth;
      this.left =
        laveWidth - this.showNavWidth > 0 ? laveWidth - this.showNavWidth : 0;
      this.showBigNav = !!(laveWidth - this.showNavWidth > 0);
      // if(this.left <= 0){
      //   this.left = 0;
      // }
      // if(navWidth){
      //   this.left = (avaWidth - 1200) / 2 -  this.showNavWidth;
      //   console.log(this.left);
      //   if(this.left <= 0){
      //     this.left = 0;
      //   }
      // }
    },
    checkTags(info) {
      if (info.mktInfoList && info.mktInfoList.length > 0) {
        // info.tags = info.mktInfoList;
        // if (!info.promPrice) {
        //   info.promPrice = info.price;
        // }
        if (!info.goodsPrice) {
          info.goodsPrice = info.originalPrice;
        }
        if (info.salePrice) {
          info.goodsPrice = info.salePrice;
        }
      }
      let newInfo = info;
      return newInfo;
    },
    updateActive() {
      const fatherNode = document.querySelectorAll(".goodlist-wrap") || [];
      const childList = Array.from(fatherNode[0] && fatherNode[0].childNodes);
      const activeItem = childList.find((item) => {
        const rect = item.getBoundingClientRect();
        return rect.height > -rect.top;
      });
      if (activeItem && activeItem.id !== this.activeValue) {
        childList.map((item) => item.classList.remove("active"));
        activeItem.classList.add("active");
        this.activeValue = activeItem.id;
      }
      // let avaWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
      // let navWidth = this.$refs.$nav.offsetWidth;
      // if(navWidth){
      //   this.left = (avaWidth - 1200) / 2 -  (navWidth + 24);
      //   if(this.left <= 0){
      //     this.left = 0;
      //   }
      // }
    },
    leaveBigNav() {
      if (this.left > 0) return;
      this.showBigNav = false;
    },
    scrollIntoFace(id, fixedTop) {
      // const documentNode = document.documentElement || document.body;
      window.scrollTo(0, document.getElementById(id).offsetTop + fixedTop);
      // documentNode.scrollTop = document.getElementById(id).offsetTop + fixedTop;
    },
    toDetail(url, type = "", goods = {}) {
      if (url) {
        window.open(url, this.isFeishuOrDingding ? '_self' : '_blank');
        // window.location.href = url;
      }
      this.sendGio(type, goods);
      console.log("数据埋点", type);
    },
    sendGio(type, goods = {}) {
      let params = {
        df_modulename: "", // 模块名称
        df_elementname: "", // 元素名
      };
      switch (type) {
        case "banner":
          params.df_modulename = "顶部kv";
          params.df_elementname = "顶部kv：图片位";
          break;
        case "DF_elementClick":
          params.df_modulename = "海景楼层";
          params.df_elementname = "海景楼层：图片位";
          break;
        case "DF_AddClick":
          params.df_modulename = "加购按钮";
          params.df_elementname = "点击加购按钮";
          break;
        case "DF_FloatClick":
          params.df_modulename = "悬浮图标";
          params.df_elementname = "悬浮图标：图片位";
          break;
        case "DF_GoodsClick":
          params.df_modulename = "商品";
          params.df_elementname = "商品位";
          try {
            params.df_spu_code = goods.spuId;
            params.df_sku_code = goods.goodsId;
            params.df_goodsname = goods.goodsName;
          } catch {
            console.log("埋点数据异常");
          }
          break;
      }
      params = Object.assign(params, goods);
      gioClickHandle("DF_elementClick", params);
    },
    sendGio(type) {
      let params = {
        df_modulename: "", // 模块名称
        df_elementname: "", // 元素名
      };
      switch (type) {
        case "banner":
          params.df_modulename = "顶部kv";
          params.df_elementname = "顶部kv：图片位";
          break;
        case "DF_elementClick":
          params.df_modulename = "海景楼层";
          params.df_elementname = "海景楼层：图片位";
          break;
      }
      gioClickHandle("DF_pageView");
    },
    toTop() {
      window.scrollTo(0, 0);
    },

    onClickAdd(goods) {
      try {
        const params = {
          df_spu_code: goods.spuId,
          df_sku_code: goods.goodsId,
          df_goodsname: goods.goodsName,
        };
        this.sendGio("DF_AddClick", params);
      } catch {
        console.log("埋点异常");
      }
      fetchSkuBySpuId({
        categoryId: goods.categoryId,
        spuId: goods.spuId,
      }).then((body) => {
        if (body) {
          // 单规格
          // console.log(body);
          if (body.length === 1) {
            const myChoose = {
              categoryId: body[0].categoryId,
              goodsId: body[0].goodsId,
              num: body[0].buyMin || 1,
            };
            this.onClickSkuAdd(myChoose);
            return;
          }
          try {
            let checkList = [];
            body &&
              body.length > 0 &&
              body.forEach((item) => {
                item.tags = [];
                if (item.categoryId && item.goodsId) {
                  checkList.push({
                    categoryId: item.categoryId,
                    goodsId: item.goodsId,
                  });
                }
              });
            checkList &&
              checkList.length > 0 &&
              getActivityTag({
                channel: 2,
                goodsList: checkList,
              }).then((res) => {
                if (res && res.length > 0) {
                  body &&
                    body.length > 0 &&
                    body.forEach((item) => {
                      item = dealTagGoods(item, res);
                    });
                  this.activeGoods = goods;
                  this.activeGoods.goodsSpecList = body;
                  this.SkuPickerShow = true;
                } else {
                  this.activeGoods = goods;
                  this.activeGoods.goodsSpecList = body;
                  this.SkuPickerShow = true;
                }
              });
          } catch (error) {
            this.activeGoods = goods;
            this.activeGoods.goodsSpecList = body;
            this.SkuPickerShow = true;
          }
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
    },
    onClickSkuAdd(myChoose) {
      this.chooseOfAdd = myChoose;
      fetchaddCart({
        categoryId: myChoose.categoryId,
        goodsId: myChoose.goodsId,
        goodsNum: myChoose.num,
        ...this.addressInfo,
      }).then((body) => {
        if (body) {
          this.dialogVisible = true;
          this.cartCount({ ...this.addressInfo });
        }
        if (body.msg) {
          Toast.info(body.msg, 1);
        }
      });
      this.onCloseSkuModal();
    },
    onCloseSkuModal() {
      this.SkuPickerShow = false;
    },
    toPageDetail(goods,url, gio) {
      if (url) {
        window.open(url, this.isFeishuOrDingding ? '_self' : '_blank');
      } else {
        window.open(
          `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`,
          this.isFeishuOrDingding ? '_self' : '_blank'
        );
      }

      this.sendGio(gio, goods);
      // window.location.href = `/shop/product/detail?cid=${goods.categoryId}&gid=${goods.goodsId}`;
    },
    onClickGoBuy() {
      window.open("/shop/shopping/cart",
      this.isFeishuOrDingding ? '_self' : '_blank'
      );
      // window.location.href = '/shop/shopping/cart';
    },
    showModal() {
      try {
        this.sendGio("DF_FloatClick");
      } catch {
        console.log("埋点异常");
      }
      this.iframeDialog = true;
    },
  },
};
</script>

<style lang="less">
.ActivityDetail {
  position: relative;
  min-height: 100vh;
  background-size: contain;
  background-position: 0 400px;
  background-repeat: repeat-y;
  .nav-left-small {
    position: fixed;
    top: 72px;
    left: 0;
    z-index: 999;
    font-size: 20px;
    padding: 16px 6px;
    font-weight: bold;
    color: #fff;
    line-height: 26px;
    // text-shadow:0px 6px 16px rgba(0,0,0,0.15), 0px 2px 4px rgba(194,71,70,0.75);
    border-radius: 0px 8px 8px 0px;
    writing-mode: vertical-lr;
    transition: all 0.3s ease-in;
  }
  .nav-left-fixed {
    position: fixed;
    top: 72px;
    padding: 15px 12px 0;
    background: #f77b7a;
    border-radius: 8px;
    text-align: center;
    z-index: 999;
    min-width: 90px;
    transition: all 0.3s ease-in;
    .nav-left-big {
      padding: 15px 12px 0;
    }
    div.tab-list-fixed {
      border-radius: 4px;
      overflow: hidden;
      text-align: center;

      .fixed-item {
        line-height: 36px;
        height: 36px;
        // padding: 0 26px;
        background: #fff;
        color: #111;
        &.active {
          font-weight: bold;
        }
      }
    }
    h3 {
      color: #fff;
      margin-bottom: 10px;
      // text-shadow:0px 6px 16px rgba(0,0,0,0.15), 0px 2px 4px rgba(194,71,70,0.75);
    }
    .scrollTop {
      margin: 10px 0;
      color: #fff;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 20px;
        height: 20px;
        margin-left: 8px;
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
  .nav-top {
    height: 48px;
    .tab-list {
      margin: 0 auto;
      width: 1200px;
    }
  }
  .banner-wrap {
    width: 100%;
    display: block;
    text-align: center;
    img {
      width: auto;
      // height: 480px;
    }
  }
  .tab-list {
    display: flex;
    height: 48px;
    line-height: 48px;
    margin-bottom: 20px;
    padding: 0 20px;
    box-sizing: border-box;
    .tab-item {
      flex: 1;
      text-align: center;
      border-radius: 24px;
      background: #ededed;
      margin-right: 20px;
      padding: 0 15px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .isSticky {
    position: fixed;
    width: 100vw;
    top: 0;
    background: #fff;
    height: 48px;
    z-index: 999;
    margin: 0 auto;
    // padding-bottom: 48px;
  }
  .goodlist-wrap {
    // padding: 0px 10px;
    padding-bottom: 100px;
    width: 1200px;
    margin: 0 auto;
    .title-img-box {
      text-align: center;
      img {
        width: auto;
      }
    }
    .row-goods-list {
      display: flex;
      // justify-content: space-between;
      margin: 28px 0;
      .good-item {
        width: 282px;
        height: 420px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        overflow: hidden;
        margin-right: 24px;
        .GoodsItem {
          margin: 0;
          width: auto;
          .imgBox {
            width: 282px;
            height: 282px;
            img {
              width: 100%;
            }
            .soldOut {
              position: absolute;
              width: 110px;
              height: 110px;
              min-height: auto;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 10;
            }
            // &:hover img {
            //   transition: none;
            //   transform: none;
            //   cursor: pointer;
            // }
            .desContent-active {
              background-size: 282px 34px;
              height: 34px;
              div {
                font-size: 15px;
                line-height: 34px;
              }
            }
          }
          .goods-name {
            padding: 0 13px;
            height: 38px;
            text-align: left;
            margin-top: 10px;
          }
          .row-price {
            padding: 0 13px;
            // margin-top: 20px;
            .price {
              font-weight: 500;
            }
          }
          // .market-row-price {
          //   margin-top: 0;
          // }
        }
      }
    }
    img {
      width: 100%;
    }
  }
  /deep/ .product-dialog {
    .title {
      margin-top: 18px;
    }
    .goods-name {
      color: #7f7f7f;
      margin-top: 18px;
    }
    .goods-sku-name {
      color: #b2b2b2;
      margin-top: 5px;
    }
  }

  .iframe-h5 {
    width: 375px;
    height: 80vh;
    outline: none;
    list-style: none;
    background: #fff;
    border: none;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
  .lottery-enter {
    position: fixed;
    width: 160px;
    height: 160px;
    right: 28px;
    bottom: 140px;
    z-index: 111;
    &:hover {
      cursor: pointer;
    }
    img {
      width: 100%;
    }
  }
}
.iframe-dialog {
  transform: translateY(-50%);
  background: #fbf7cc;
}
.el-dialog__wrapper {
  overflow: visible;
}
.nav-transition-enter, .nav-transition-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
.nav-transition-enter-to,
.nav-transition-leave {
  opacity: 1;
}
</style>